import dayjs from "dayjs";

const LOCALE = "en-IN";

export function formatValue(value, format = "number", { compact = false } = {}) {
	if (value === null || value === undefined || value === "") {
		return "—";
	}
	if (typeof value !== "number") {
		return String(value);
	}
	const options = compact ? { notation: "compact", maximumFractionDigits: 1 } : { maximumFractionDigits: 2 };
	if (format === "percent") {
		return `${value.toLocaleString(LOCALE, options)}%`;
	}
	if (format === "currency_inr") {
		return `₹${value.toLocaleString(LOCALE, compact ? options : { maximumFractionDigits: 0 })}`;
	}
	return value.toLocaleString(LOCALE, options);
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}(T|$)/;

/** Short label for an x-axis value: dates become "12 Jun" / "Jun 2025". */
export function formatCategory(value, allValues = []) {
	if (typeof value !== "string" || !ISO_DATE.test(value)) {
		return value;
	}
	const date = dayjs(value);
	const monthly = allValues.length > 1 && allValues.every((v) => typeof v === "string" && v.slice(8, 10) === "01");
	return monthly ? date.format("MMM YYYY") : date.format("D MMM");
}

export function humanizeKey(key) {
	return key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}
